module.exports = __webpack_public_path__ + "60c2d93ef1c5db7bad69d86e081b5fe5.svg";